import { useRequest } from 'ahooks';

import {updateSavedFoldInfo, createSavedFold, saveContent, deleteSavedFold, deleteSavedContent} from '../axios/api'

function useMarkAction(){

    const {loading:updateSavedFoldInfoLoading,data:updateSavedFoldInfoState,runAsync:updateSavedFoldInfoAction} = useRequest(
        async (params)=>{
            try {
                const resp = await updateSavedFoldInfo({
                    ...params
                });
                if(!resp?.data?.includes("success")){
                    // message.error("更新失败")
                    return false
                }    
                // message.success("已更新") 
                return true;
            }catch(error){
                // message.error('更新失败')
                return false
            }
        },
        {
            debounceWait: 100, // 从240ms减少到100ms
            manual: true,
        }
    );
    
    const {loading:createSavedFoldLoading,data:createSavedFoldData,runAsync:createSavedFoldAction} = useRequest(
        async (params)=>{
            try {
                const resp = await createSavedFold({...params});
                if(!resp?.data?.fold_id){
                    // message.success("新建失败")
                }
                return resp?.data?.fold_id
            }catch(error){
                // message.success("新建失败")
                return undefined
            }
        },
        {
            debounceWait: 100, // 从240ms减少到100ms
            manual: true,
        }
    );
    const {loading:saveContentLoading,data:saveContentState,runAsync:saveContentAction} = useRequest(
        async (params)=>{
            try {
                const resp = await saveContent({...params});
                if(!resp?.data?.save_id){
                    // message.error("收藏失败")
                    return undefined
                }   
                // message.success("收藏成功") 
                return resp?.data?.save_id
            }catch(error){
                // message.error('收藏失败')
                return undefined
            }
        },
        {
            debounceWait: 100, // 从240ms减少到100ms
            manual: true,
        }
    );
    const {loading:deleteSavedFoldLoading,data:deleteSavedFoldState,runAsync:deleteSavedFoldAction} = useRequest(
        async (params)=>{
            try {
                const resp = await deleteSavedFold({...params});
                if(!resp?.data?.includes("success")){
                    // message.error("删除失败")
                    return false
                }   
                // message.success("已删除") 
                return true;
            }catch(error){
                // message.error('删除失败')
                return false
            }
        },
        {
            debounceWait: 100, // 从240ms减少到100ms
            manual: true,
        }
    );
    const {loading:deleteSavedContentLoading,data:deleteSavedContentState,runAsync:deleteSavedContentAction} = useRequest(
        async (params)=>{
            try {
                const resp = await deleteSavedContent({...params});
                if(!resp?.data?.includes("success")){
                    // message.error("删除失败")
                    return false
                }   
                // message.success("已删除") 
                return true;
            }catch(error){
                // message.error('删除失败')
                return false
            }
        },
        {
            debounceWait: 100, // 从240ms减少到100ms，提升响应速度
            manual: true,
        }
    );

    return{
        updateSavedFoldInfoLoading,
        updateSavedFoldInfoState,
        updateSavedFoldInfoAction,

        createSavedFoldLoading,
        createSavedFoldData,
        createSavedFoldAction,

        saveContentLoading,
        saveContentState,
        saveContentAction,

        deleteSavedFoldLoading,
        deleteSavedFoldState,
        deleteSavedFoldAction,

        deleteSavedContentLoading,
        deleteSavedContentState,
        deleteSavedContentAction
    }
}

export default useMarkAction